export const getHeaders = (selectedCallHistoryFields) =>
	selectedCallHistoryFields.map((field) => field.label);
